import * as apiUrl from "../../apiUrl";



export const fetchOurIdentityPageData = async () => {
  try {
    const endpoints = [
      "/api/our-identity/banner-section",
      "/api/our-identity/second-section",
      "/api/our-identity/third-section",
      "/api/our-identity/fourth-section",     
    ];

    const fetchPromises = endpoints.map(async (endpoint) => {
      const url = apiUrl.apiUrl + endpoint;
      const response = await fetch(url);
      if (!response.ok) {
        console.error(`Failed to fetch ${url}: Status ${response.status}`);
        throw new Error(`HTTP error ${response.status}`);
      }
      return response.json();
    });

    const [
      banner,
      second,
      third,
      fourth,      
    ] = await Promise.all(fetchPromises);

    return { banner, second, third, fourth };
  } catch (error) {
    console.error("Error fetching Our Identity page data:", error);
    return null;
  }
};


